import {Component} from "../Components/Component";
import {createLogger} from "../util/logger";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import gsap from "gsap";
import {AjaxNavigation} from "../Components/AjaxNavigation";

const console = createLogger("FrontPage");

export class FrontPage extends Component {
    static name = "front-page";

    get name() {
        return FrontPage.name;
    }

    constructor(el) {
        super(el);

        /**
         * List of elements with custom themes
         * @type {HTMLElement[]}
         */
        this.$themeBlocks = this.querySelectorAll(`[${this.getComponentAttributeName("theme")}]`);


        /**
         * @type {HTMLElement[]}
         */
        this.$nextPageLink = this.$("nextPageLink");


        /**
         * @type {HTMLElement[]}
         */
        this.$nextPageContent = this.$("nextPageContent");


        this.addEventListener(this.$nextPageLink, "click", this.onClickNextPage.bind(this));


        gsap.set(this.$themeBlocks.slice(1), {
            visibility: "hidden",
            opacity: 0,
        })

        this.$nextPageLink.forEach((link) => {
            gsap.set(link, {
                "--height": link.firstElementChild.offsetHeight + "px",
            });
        }),

        this.scrollTriggers = this.$nextPageLink.map((el, i) => {
            return ScrollTrigger.create({
                trigger: el,
                pin: true,
                start: "top-=200px center",
                end: "+=" + window.innerHeight * 0.5, // * 0.35,
                onUpdate: (self) => {
                    el.style.setProperty("--progress", self.progress.toFixed(3));

                    if (self.progress === 1) {

                        if (!this.$themeBlocks[i + 1]) return;

                        gsap.to(window, {
                            duration: 0.3,
                            scrollTo: this.$themeBlocks[i + 1].offsetTop - 200,
                        });

                        gsap.to(this.$nextPageContent, {
                            visibility: "visible",
                            opacity: 1,
                            duration: 0.3,
                        });

                    }
                },
            });
        });


        // Configure theme switching based on current visible block
        this.scrollTriggers.push(...this.$themeBlocks.map((el, i) => {
            const theme = el.getAttribute(this.getComponentAttributeName("theme"));

            const onEnter = () => document.body.classList.add(`theme-${theme}`);

            const onLeave = () => document.body.classList.remove(`theme-${theme}`);

            return ScrollTrigger.create({
                trigger: el,
                start: "top center",
                end: "bottom center",
                onEnter: () => {
                    console.log("onEnter", theme, el);
                    onEnter();
                },
                onEnterBack: () => {
                    onEnter();
                    console.log("onEnterBack", theme, el);
                },
                onLeave: () => {
                    // Do not remove class in last block
                    if (i === this.$themeBlocks.length - 1) return;
                    console.log("onLeave", theme, el);
                    onLeave();
                },
                onLeaveBack: () => {
                    // Dont remove class on first block
                    if (i === 0) return;
                    onLeave();
                }
            });
        }));

        this.addEventListener(document.body, AjaxNavigation.EVENT_LOAD_START, () => {
            console.log(AjaxNavigation.EVENT_LOAD_START);
            this.scrollTriggers.forEach((trigger) => trigger.kill());
            this.isNavigating = true;
        });

        this.addEventListener(document.body, AjaxNavigation.EVENT_LOAD_END, () => {
            console.log(AjaxNavigation.EVENT_LOAD_END);
            this.isNavigating = false;
        });

        this.addEventListener(window, "DOMContentLoaded", () => {
            console.log("UpdateScrollTrigger");
            ScrollTrigger.refresh();
            setTimeout(() => {
                ScrollTrigger.refresh()
            }, 2000);
        });

        this.addEventListener(window, "load", () => {
            console.log("window.load");
        });



        console.log(this);
    }

    /**
     *
     * @param {MouseEvent} e
     */
    onClickNextPage(e) {
        e.preventDefault();
        e.stopPropagation();
    }

    destroy() {
        super.destroy();

        this.scrollTriggers.forEach((trigger) => trigger.kill());
    }

}
